// extracted by css-extract-rspack-plugin
var _1 = "WV8D96o3kP0U9Nlp";
var _2 = "FTzz1Svq3jQteVlX";
var _3 = "qYzOKUa2kYKu61TU";
var _4 = "gFhL6B62tIcHZKRc";
var _5 = "s8aX5EjWZkouw_QR";
var _6 = "YLGBWfqs6j0pu9hp";
var _7 = "S5Fh1Gis7dkGfYk5";
export { _1 as "arrow", _2 as "arrow-holder", _3 as "arrowDisabled", _4 as "galleryHolder", _5 as "singleSlide", _6 as "slider", _7 as "sliderInnerWrap" }
// extracted by css-extract-rspack-plugin
var _1 = "WV8D96o3kP0U9Nlp";
var _2 = "FTzz1Svq3jQteVlX";
var _3 = "qYzOKUa2kYKu61TU";
var _4 = "gFhL6B62tIcHZKRc";
var _5 = "s8aX5EjWZkouw_QR";
var _6 = "YLGBWfqs6j0pu9hp";
var _7 = "S5Fh1Gis7dkGfYk5";
export { _1 as "arrow", _2 as "arrow-holder", _3 as "arrowDisabled", _4 as "galleryHolder", _5 as "singleSlide", _6 as "slider", _7 as "sliderInnerWrap" }
